import type { ReactNode } from 'react'
import { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next'
import Head from 'next/dist/shared/lib/head'
import { FAVICON_LINK_KEYS } from 'shared/constants'
import type { DomainAssetsInterface } from 'shared/types/domain'
import Header from 'modules/header'
import { useBrand } from 'modules/white-label/contexts/brand-context'

export interface ProfilePageLayoutProps {
  titleKey?: ParseKeys
  domainAssets?: DomainAssetsInterface
}

export const ProfilePageLayout = ({
  titleKey = 'profile.user_settings.profile.title',
  children,
  domainAssets,
}: React.PropsWithChildren<ProfilePageLayoutProps>): ReactNode => {
  const { t } = useTranslation()

  const { brand } = useBrand()

  return (
    <>
      <Head>
        <title>{t(titleKey)}</title>
        {domainAssets?.faviconUrl && (
          <link key={FAVICON_LINK_KEYS.icon} rel="icon" href={domainAssets.faviconUrl} />
        )}
      </Head>
      <Header logoSrc={domainAssets?.logoUrl || brand.logo?.path} />
      <div className="overflow-hidden">
        <div className="mx-auto max-w-8xl overflow-hidden px-5 py-4 sm:px-6 md:px-5 lg:py-9">
          {children}
        </div>
      </div>
    </>
  )
}

export const getProfilePageLayout = (
  page: ReactNode,
  props?: ProfilePageLayoutProps,
): ReactNode => <ProfilePageLayout {...props}>{page}</ProfilePageLayout>
